import { addMinutes } from 'date-fns';

/*
 * We will soon deprecate moment in favor of date-fns.
 * Moment is still required here due to the DateRange component.
 */
import moment from 'moment';

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const getMomentUtcDateRangeFromFormat = (startDate, endDate, format) => {
  const startDateResult = getMomentUtcDateFromFormat(startDate, format).startOf('day');
  const endDateResult = getMomentUtcDateFromFormat(endDate, format).endOf('day');
  return { startDateResult, endDateResult };
};

export const getMomentUtcDateFromFormat = (date, format) => {
  return moment.utc(date.format(format));
};

export const datediff = (start) => {
  let today = new Date();
  let startDate = new Date(start);
  startDate = Date.parse(startDate);
  today.setHours(23);
  today.setMinutes(59);
  today = Date.parse(today);
  return Math.round((today - startDate) / (1000 * 60 * 60 * 24));
};

export const getDatesArray = (datesArray, filterRange) => {
  let sortArray = datesArray.sort(function (a, b) {
    return Date.parse(a.date) - Date.parse(b.date);
  });

  const exampleObj = {
    total_orders: 0,
    total_income: 0,
    total_items: 0,
  };

  let endDate = new Date();
  let startDate = endDate.setDate(endDate.getDate() - 30);
  if (filterRange && filterRange.start && filterRange.end) {
    startDate = filterRange.start;
    endDate = filterRange.end;
  }

  let dt;
  if (typeof startDate === 'string') {
    startDate = new Date(filterRange.start);
    endDate = new Date(filterRange.end);
  } else {
    dt = Date.parse(endDate) - Date.parse(startDate);
  }

  let dateArr = getDateArray(startDate, endDate);
  let readyArray = [];

  for (let i = 0; i < dateArr.length; i++) {
    let flag = true;
    if (sortArray.length === 0) {
      let emptyData = Object.assign({}, { date: dateArr[i] }, exampleObj);
      readyArray.push(emptyData);
      continue;
    }
    for (let j = 0; j < sortArray.length; j++) {
      const jDate = new Date(sortArray[j].date);
      const iDate = dateArr[i];
      const jDay = jDate.getDate(),
        jMonth = jDate.getMonth(),
        jYear = jDate.getFullYear(),
        iDay = iDate.getDate(),
        iMonth = iDate.getMonth(),
        iYear = iDate.getFullYear();
      if (jDay === iDay && jMonth === iMonth && jYear === iYear) {
        const targetObj = {
          ...sortArray[j],
          date: dateArr[i],
        };
        readyArray.push(targetObj);
        flag = false;
      }
    }
    if (flag) {
      const zeroObject = Object.assign({}, sortArray[0]);
      Object.keys(zeroObject).forEach((key) => {
        if (key === 'date') {
          zeroObject.date = dateArr[i];
        } else {
          zeroObject[key] = 0;
        }
      });

      readyArray.push(zeroObject);
      flag = false;
    }
  }
  if (dt > 2419200000 && dt < 6048000000) {
    // 4 weeks < dt < 10 weeks
    return groupByWeeks(readyArray);
  }
  if (dt > 4838400000) {
    // dt > 8 weeks
    return groupingByMonths(readyArray);
  }
  return readyArray.map(function (item) {
    item.date = `${item.date.getDate()}.${item.date.getMonth() + 1}`;
    return item;
  });
};

const groupByWeeks = (readyArray) => {
  let weeksInArrays = [[]];
  const weeks = readyArray.map((item) => {
    item.date = getWeekNumberInMonth(item.date);
    return item;
  });

  weeks.forEach((item, i) => {
    if (i === 0) weeksInArrays[weeksInArrays.length - 1].push(item);
    if (i !== weeks.length - 1) {
      if (item.date === weeks[i + 1].date) {
        weeksInArrays[weeksInArrays.length - 1].push(item);
      }
      if (item.date !== weeks[i + 1].date) {
        weeksInArrays[weeksInArrays.length - 1].push(item);
        weeksInArrays.push([]);
      }
    } else {
      if (item.date === weeks[i - 1].date) {
        weeksInArrays[weeksInArrays.length - 1].push(item);
      }
      if (item.date !== weeks[i - 1].date) {
        weeksInArrays[weeksInArrays.length - 1].push(item);
      }
    }
  });

  return weeksInArrays.map((item) => {
    const obj = { date: '', total_orders: 0, total_income: 0, total_items: 0 };
    for (let i = 0; i < item.length; i++) {
      obj.date = item[i].date;
      Object.keys(item[i]).forEach((key) => {
        if (key !== 'date') {
          obj[key] = obj[key] + +item[i][key];
        }
      });
    }
    return obj;
  });
};

const groupingByMonths = (readyArray) => {
  let monthes = [];
  let readyMonthes = [];
  readyArray.forEach((item) => {
    let numberMonth = new Date(item.date).getMonth();
    let monthName = MONTH_NAMES[numberMonth].substring(0, 3);
    let year = new Date(item.date).getFullYear();
    monthes.push({ monthName, year, data: item });
  });
  monthes.forEach((item, i) => {
    if (i === 0) readyMonthes.push(item);
    if (monthes[i - 1] !== undefined && item.monthName !== monthes[i - 1].monthName) {
      readyMonthes.push(item);
    }
    if (monthes[i - 1] !== undefined && item.monthName === monthes[i - 1].monthName) {
      const lastDate = readyMonthes[readyMonthes.length - 1];

      Object.keys(lastDate.data).forEach((key) => {
        if (lastDate.data[key] === 'date') {
          lastDate.data.date = item.data.date;
        }
        lastDate.data[key] = lastDate.data[key] + item.data[key];
      });

      readyMonthes[readyMonthes.length - 1] = lastDate;
    }
  });

  return readyMonthes.map((item) => {
    item.data.date = `${item.monthName} '${item.year - 2000}`;
    delete item.year;
    delete item.monthName;
    return item.data;
  });
};

const getDateArray = (start, end) => {
  const dates = [];
  let date = new Date(start);
  while (date <= end) {
    dates.push(new Date(date));
    date = new Date(date);
    date.setDate(date.getDate() + 1);
  }
  return dates;
};

const getWeekNumberInMonth = (date) => {
  const firstDayWeek = new Date(Date.parse(date)),
    lastDayWeek = new Date(Date.parse(date)),
    day = date.getDay(),
    delta = 6 - day;
  firstDayWeek.setDate(date.getDate() - day);
  lastDayWeek.setDate(date.getDate() + delta);
  const firstDayMonthName = MONTH_NAMES[firstDayWeek.getMonth()].substring(0, 3);
  const lastDayMonthName = MONTH_NAMES[lastDayWeek.getMonth()].substring(0, 3);
  return `${firstDayWeek.getDate()} ${firstDayMonthName} - ${lastDayWeek.getDate()} ${lastDayMonthName}`;
};

export function getValidDateFromLocalStorage(key, defaultValue = moment().startOf('day')) {
  try {
    const value = window.localStorage.getItem(key);
    const date = value ? moment.utc(new Date(value)) : defaultValue;
    return date.isValid() ? date : defaultValue;
  } catch (error) {
    return defaultValue;
  }
}

export function dateInUTC(date) {
  const dateObject = new Date(date);
  return addMinutes(dateObject, dateObject.getTimezoneOffset());
}

export function addLocalTimezoneOffset(date) {
  const dateObject = new Date(date);
  return new Date(dateObject.getTime() + dateObject.getTimezoneOffset() * (60 * 1000));
}
